import { useState, useEffect, useCallback } from 'react';
import { getCurrentBiddings } from "../components/api"
import { BiddingListItem } from "../components/BiddingListItem";
import '../styles/bidding-list.scss';
import { useUnit } from 'effector-react';
import { $isAuth, $userData, $userDataLoaded } from '../store';
import { Popup } from '../components';
import { Button, Typography } from '@mui/material';

export const CurrentBiddings = () => {
    const [biddings, setBiddings] = useState([]);
    const [page, setPage] = useState(0);
    const [hasMore, setHasMore] = useState(true);
    const [loading, setLoading] = useState(false);
    const [showPopup, setShowPopup] = useState(false);
    const [selectedBiddingId, setSelectedBiddingId] = useState(0);

    const isAuth = useUnit($isAuth);
    const userData = useUnit($userData);
    const userDataLoaded = useUnit($userDataLoaded);

    const biddingsLimit = 8;

    const loadMoreBiddings = useCallback(async () => {
        if (loading || !hasMore || !userDataLoaded) return;
        setLoading(true);

        try {
            const data = await getCurrentBiddings(biddingsLimit, page * biddingsLimit, userData?.id);

            if (data && data.length > 0) {
                setBiddings(prevBiddings => [...prevBiddings, ...data]);
                setPage(prevPage => prevPage + 1);
                if (data.length < biddingsLimit) {
                    setHasMore(false);
                }
            } else {
                setHasMore(false);
            }
        } catch (error) {
            console.error("Ошибка получения торгов:", error);
        } finally {
            setLoading(false);
        }
    }, [loading, hasMore, page, biddingsLimit, userData, userDataLoaded]);

    useEffect(() => {
        loadMoreBiddings();
    }, [userDataLoaded]);

    useEffect(() => {
        const handleScroll = () => {
            if (
                window.innerHeight + document.documentElement.scrollTop >= document.documentElement.offsetHeight - 100
            ) {
                loadMoreBiddings();
            }
        };

        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, [loadMoreBiddings]);

    const goToBiddingCard = (id) => {
        if (isAuth) {
            window.location.href = `/bidding/${id}?returnUrl=${window.location.pathname}`;
        }
        else {
            setSelectedBiddingId(id);
            setShowPopup(true);
        }
    }

    return (
        <div className='bidding-list'>
            <h2 key={"currentBiddings"}>Аукционы</h2>
            {biddings.map(bidding => (
                <BiddingListItem key={bidding.id} data={bidding} status={"active"} onClick={() => goToBiddingCard(bidding.id)} />
            ))}
            {loading && <p>Загрузка...</p>}
            {!hasMore && !loading && <p style={{ textAlign: 'center' }}> </p>}
            <Popup show={showPopup} onClose={() => setShowPopup(false)}>
                <Typography variant="h6">Для перехода к лоту необходимо авторизоваться</Typography>
                <a href={`/authorization?returnUrl=/bidding/${selectedBiddingId}?returnUrl=${window.location.pathname}`}>
                    <Button variant="contained">Войти</Button>
                </a>
            </Popup>
        </div>
    );
};